import { COLORS } from 'helpers/globals'

const meterButton = {
  display: 'inline',
  fontWeight: 300
}

export default {
  floorPlanScaler: {
    position: 'absolute',
    top: 0,
    right: 0,
    width: 435,
    height: '100%',
    overflowY: 'auto',
    padding: 0
  },
  topUiControls: {
    fontSize: '1.6rem',
    padding: '.5rem',
    backgroundColor: COLORS.tertiary,
    borderBottom: `1px solid ${COLORS.quaternary}`
  },
  goBackButton: {
    marginRight: 7
  },
  label: {
    lineHeight: '3.5rem',
    color: 'black',
    marginLeft: '.8rem',
    marginBottom: '.8rem'
  },
  instructionList: {
    marginLeft: '2rem',
    marginBottom: '1rem',
    lineHeight: '1.5rem',
    listStylePosition: 'outside',
    color: 'black'
  },
  widthInput: {
    margin: '0 2.5rem',
    width: '30%'
  },
  meterButton,
  feetButton: {
    ...meterButton,
    marginRight: '1.5rem'
  },
  buttonWrapper: {
    marginLeft: '2.5rem',
    marginTop: '1rem'
  },
  scaleIcon: {
    fontSize: '2rem',
    marginRight: '.5rem',
    verticalAlign: '-5px'
  },
  scaleButton: {
    fontSize: '1.4rem',
    background: COLORS.primary,
    color: 'white',
    borderRadius: 2,
    padding: '.75rem 1.5rem',
    '&:hover': {
      background: '#68B1F0',
      color: 'white'
    }
  },
  cancelButton: {
    marginLeft: '1rem',
    fontSize: '1.4rem',
    background: '#999999',
    color: 'black',
    borderRadius: 2,
    padding: '.75rem 1.5rem',
    '&:hover': {
      background: '#737373',
      color: 'black'
    }
  },
  spacer: {
    paddingTop: '20rem'
  }
}



// WEBPACK FOOTER //
// ./src/components/FloorPlan/FloorPlanScaler/style.js